export default "__VITE_ASSET__16147d38__"